import { render, staticRenderFns } from "./OMAutoComplete.vue?vue&type=template&id=0bba3b1c"
import script from "./OMAutoComplete.vue?vue&type=script&lang=js"
export * from "./OMAutoComplete.vue?vue&type=script&lang=js"
import style0 from "./OMAutoComplete.vue?vue&type=style&index=0&id=0bba3b1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../omniscient/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports